var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('div',{staticClass:"c-input-div row-center align-center g-5",attrs:{"name":_vm.uniqueTooltipName}},[_c('span',{staticClass:"text-xsmall"},[_vm._v(_vm._s(_vm.properties.label))]),_vm._v(" "),_c('CIcon',{attrs:{"icon":_vm.properties.icon}})],1),_vm._v(" "),(false)?_vm._t("inputHelper"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }